import { gql } from '@apollo/client';

// 'status' field temporary removed
export const UPDATE_CASE_FORM = gql`
    mutation updateCaseForm($input: CaseFormInput!) {
        updateCaseForm(input: $input) {
            caseForm {
                id
                title
                content
                version
                comments {
                    id
                    text
                    timestamp
                    user {
                        id
                        email
                        firstName
                        lastName
                    }
                }
                createdAt
                createdBy {
                    email
                    firstName
                    lastName
                }
                lastEditedAt
                lastEditedBy {
                    email
                    firstName
                    lastName
                }
                lastReviewedAt
                lastReviewedBy {
                    email
                    firstName
                    lastName
                }
            }
        }
    }
`;
